import React, { useCallback } from 'react';

export const ScrollToMe = ({ className }: { className?: string }) => {
  const onRef = useCallback((el: HTMLDivElement | null) => {
    if (el) {
      el.scrollIntoView();
    }
  }, []);
  return <div className={className} ref={onRef} />;
};
